import cx from 'classnames'
import { ComponentProps, ReactNode } from 'react'

import styles from './Menu.module.scss'
import Link, { Props as LinkProps } from '../../navigation/Link'

interface OwnProps {
    icon?: React.ReactNode
    resolver?: Required<ComponentProps<typeof Link>['resolver']>
    badge?: ReactNode
}

type Props = OwnProps & Omit<LinkProps, 'category'>

const AccountDashboardMenuTab = ({
    badge,
    name,
    className,
    icon,
    children,
    ...otherProps
}: Props) => (
    <Link
        name={name}
        category="account.menu.tab"
        className={cx(styles.menuLink, className)}
        activeClassName={styles.active}
        {...otherProps}
        variant="camouflaged"
    >
        {icon && <span className={styles.icon}>{icon}</span>}
        {children}
        {badge && <span className={styles.badge}>{badge}</span>}
    </Link>
)

export default AccountDashboardMenuTab
